// extracted by mini-css-extract-plugin
module.exports = {"table":"QueryTable_table__255Bx"};